<template>
    <div class="text-center">
        <i class="d-none d-sm-inline-block fa-lg fa-solid my-3 my-sm-0 me-2 fa-triangle-exclamation"></i>
        <p class="d-inline">Order in the next <b><span v-if="hours > 0">{{ hours }} hour{{ hours == 1 ? '' : 's' }}</span> <span v-if="minutes > 0">{{ minutes }} minute{{ minutes == 1 ? '' : 's' }}</span> <span v-if="hours == 0 && minutes == 0"> {{ seconds }} second{{ seconds == 1 ? '' : 's' }}</span></b> to get your tyres fitted before the bank holiday!</p>
    </div>
</template>

<script>
    import dayjs from '@frontend/node_modules/dayjs';

    export default {
        data() {
            return {
                hours: null,
                minutes: null,
                seconds: null
            }
        },
        mounted() {
            this.calculateCutOffTime();

            let vm = this;

            setInterval(function() {
                vm.calculateCutOffTime();
            }, 1000);
        },
        methods: {
            calculateCutOffTime: function() {
                var duration = require('@frontend/node_modules/dayjs/plugin/duration');
                dayjs.extend(duration);

                var now = dayjs().format('YYYY-MM-DD H:mm:ss');
                var cutOff = '2025-08-21 17:00:00';

                if(dayjs().isBefore(cutOff)) {
                    this.hours = parseInt(dayjs.duration(dayjs(cutOff).diff(now)).format('HH'));
                    this.minutes = parseInt(dayjs.duration(dayjs(cutOff).diff(now)).format('mm'));
                    this.seconds = parseInt(dayjs.duration(dayjs(cutOff).diff(now)).format('s'));
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>